export const MAINTENANCE_SOURCE = {
  ECO_INSPECTION: "ECO Abfahrtskontrolle",
  ECO_PM: "ECO Predictive Maintenance",
} as const;

export type MaintenanceSource = (typeof MAINTENANCE_SOURCE)[keyof typeof MAINTENANCE_SOURCE];
